import { PlatformModule } from '@angular/cdk/platform';
import { NgModule } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';

import { LcsDateTimeAdapter, LcsRelativeDateTimeAdapter } from './date-time-adapter';
import { LCS_DATE_TIME_FORMATS } from './date-time-formats';
import { LCS_RELATIVE_NATIVE_DATE_TIME_FORMATS } from './native-date-time-formats';
import { RelativeNativeDateTimeAdapter } from './relative-native-date-time-adapter';

/**
 * Provides the default LCS native date time adapter for components that require an LcsDateTimeAdapter.
 */
@NgModule({
   imports: [PlatformModule],
   providers: [
      { provide: LcsDateTimeAdapter, useClass: RelativeNativeDateTimeAdapter },
      { provide: DateAdapter, useClass: RelativeNativeDateTimeAdapter },
      { provide: LcsRelativeDateTimeAdapter, useClass: RelativeNativeDateTimeAdapter },
   ],
})
export class LcsRelativeNativeDateTimeModule {}

/**
 * Provides the default LCS native date time adapter and date time formats
 * for use by the LCS date time picker and material date pickers
 */
@NgModule({
   imports: [LcsRelativeNativeDateTimeModule],
   providers: [
      { provide: LCS_DATE_TIME_FORMATS, useValue: LCS_RELATIVE_NATIVE_DATE_TIME_FORMATS },
      { provide: MAT_DATE_FORMATS, useValue: LCS_RELATIVE_NATIVE_DATE_TIME_FORMATS },
   ],
})
export class LcsNativeDateTimeModule {}
